<div class="history-card">
  <div class="_ta-card-top">
    <div class="_ta-card-left"> <!--Notes Icons-->
      <i class="fa fa-file-text" aria-hidden="true"></i>
    </div>
    <div class="_ta-card-right">
      <!-- Header Section -->
      <div class="history-header">
        <div class="_temp-top-section">
          <span [ngClass]="{ 'draft-color': getValue(item, headerField[0]).status === 'Draft','final-color': getValue(item, headerField[0]).status === 'Final' }">
            ({{ getValue(item, headerField[0]).status }})
          </span>
          <div class="_temp-name">
            {{ getValue(item, headerField[0]).text }}
          </div>
        </div>
      </div>
      <!--Sub Header Section-->
      <div class="history-subheader">
        @for (field of subHeaderField; track field; let i = $index) {
          <span>
            {{ getValue(item, field) }}@if (i < subHeaderField.length - 1) {
            <span> ,</span>
          }
        </span>
      }
    </div>
  </div>
</div>

<!-- Other Fields Section (No Changes) -->
<div class="history-container">
  @for (field of OtherField; track field; let i = $index) {
    <div class="_wf-historytableft">
      <div class="_wf-historycategory">{{ field.heading | translate | async }}</div>
      <div class="_wf-historybolddtata">{{ getValue(item, field) }}</div>
    </div>
  }
</div>
</div>